import React from "react";
import Card from "../../share/cards/Card";
import { BtnAlternative } from "../../share/buttons/Btn";

function PllTable(props) {
    return (
        <div className="mx-24 py-24">
            <Card className="SupportTicketTable-card-small SupportTicketTable-header ">
                {props.header.map((item, id) => (
                    <div>{item.title}</div>
                ))}
            </Card>
            {props.list?.map((i, id) => (
                <Card
                    key={i?.id}
                    className="SupportTicketTable-card-small SupportTicketTable-body  my-4"
                >
                    <div>{i?.question_type}</div>
                    <div>{i?.date}</div>

                    <div>
                        <p>{i.test}</p>
                    </div>
                    <div>
                        {i?.isAnswered ? (
                            <p className=" text-[#77498F] font-normal text-[1.6rem] leading-[2.4rem] cursor-pointer">
                                نمایش
                            </p>
                        ) : (
                            <BtnAlternative
                                text={"شرکت در نظرسنجی"}
                                className="px-10 py-6 self-center"
                                onClick={() => props.showModal(true)}
                            />
                        )}
                    </div>
                </Card>
            ))}
            {props.children}
        </div>
    );
}

export default PllTable;
